import { FC } from 'react'
import LeadField from '../../components/LeadField/LeadField'
import { useCRMContext } from '@pages/Admin/CRM/CRMContext'
import classes from './index.module.css'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'
import { Lead } from '@/api/types/crm.types'
import { getLeadFieldValue } from '@pages/Admin/CRM/utils/leadFields'

interface NarrowAboutContentProps {
  lead?: Lead
  fieldsData: Record<string, string>
  updateFieldData: (uniqueNameField: string, value: string) => void
}

const NarrowAboutContent: FC<NarrowAboutContentProps> = ({
  lead,
  fieldsData,
  updateFieldData,
}) => {
  const {
    preloadingData: { fields: allFields },
  } = useCRMContext()
  const { currentRole, ...access } = useFullLeadModalAccess()
  const optionalSmallFields = allFields.filter(
    (field) =>
      field.is_active && !field.is_default && field.type !== 'textarea',
  )

  return (
    <div className={classes.listSmallFields}>
      {optionalSmallFields.map((field) => {
        const defaultValue = getLeadFieldValue(lead, field.unique_name) ?? ''
        const currentValue = fieldsData[field.unique_name] ?? ''

        return (
          <LeadField
            key={field.id}
            field={field}
            value={fieldsData[field.unique_name] ?? ''}
            onChange={(val) => updateFieldData(field.unique_name, val)}
            fieldSettings={{
              phoneNumber: {
                withIntegrations: access.canInteractWithIntegrations &&
                  lead &&
                  !!defaultValue &&
                  currentValue === defaultValue && {
                    lead,
                    fieldId: field.id,
                    fieldSettings: field.settings,
                  },
              },
            }}
            disabled={!access.canEditFields}
          />
        )
      })}
    </div>
  )
}

export default NarrowAboutContent
